module.exports = __webpack_public_path__ + "img/soft-grove-bathroom-2.2a6a3d4e.jpeg";